import * as processENV from '@/processENV';
import storage from './storage';
const { VITE_XMPP_SOCKET_HOST } = processENV;

export const getLocalUserId = () => storage.getItem('username') || '';

export const getUserIdFromJid = userJid => {
   if (userJid) {
      return userJid.includes('@') ? userJid.split('@')[0] : userJid;
   }
   return '';
};

export const formatUserIdToJid = (userId, chatType = 'chat') => {
   if (!userId || userId.includes(`${VITE_XMPP_SOCKET_HOST}`)) return userId;
   return chatType === 'chat' ? `${userId}@${VITE_XMPP_SOCKET_HOST}` : `${userId}@mix.${VITE_XMPP_SOCKET_HOST}`;
};
